"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPLASH_FUND_DESCRIPTOR_COPY = exports.SPLASH_FUND_INFO_LABEL_COPY = exports.SPLASH_FUND_INFO_COPY = void 0;
/**
 * SF-01 (Anthony, Slack, 2026-10-13; ANTHONY-REDESIGN-2026-10-13.md): an info circle next
 * to "Splash Fund" everywhere it appears, hover on web and tap on phones, saying that the
 * Splash Fund is discretionary spending. One wording for both clients (rule 17).
 */
exports.SPLASH_FUND_INFO_COPY = "Your Splash Fund is your discretionary spending: money for whatever you like, once bills, savings and everyday spending are set aside.";
/** The info circle's accessible name. */
exports.SPLASH_FUND_INFO_LABEL_COPY = "What is Splash Fund?";
/** The short line under a Splash Fund figure, in the definition's own words ("a label
 *  called discretionary", Anthony's other option). Replaces "Your money to enjoy". */
exports.SPLASH_FUND_DESCRIPTOR_COPY = "Discretionary spending";
//# sourceMappingURL=splashFundInfoCopy.js.map